// Debounce function
function brookings_alg_debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

const snippet_class = ".ais-Snippet";
const snippet_tag = ".ais-Snippet-highlighted";

// find all snippet divs on the page, if there are no results then hide the snippet.
const hide_unused_snippets = brookings_alg_debounce(() => {
    $(snippet_class).each(function(i, element) {
        if ($(element).find(snippet_tag).length > 0) {
            $(element).css('display', 'block');
        } else {
            $(element).css('display', 'none');
        }
    });
}, 250, false);

export default hide_unused_snippets;